import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import AppStateProvider, { useAppState } from './state';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import ErrorDialog from './components/ErrorDialog/ErrorDialog';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import theme from './theme';
import './types';
import { ChatProvider } from './components/ChatProvider';
import { VideoProvider } from './components/VideoProvider';
import useConnectionOptions from './utils/useConnectionOptions/useConnectionOptions';
import UnsupportedBrowserWarning from './components/UnsupportedBrowserWarning/UnsupportedBrowserWarning';
import PortalPage from './components/PortalPage';

const VideoApp = () => {
  const { error, setError } = useAppState();
  const connectionOptions = useConnectionOptions();

  useEffect(() => {
    window.addEventListener('beforeunload', handleWindowBeforeUnload);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    () => {
      window.removeEventListener('beforeunload', handleWindowBeforeUnload);
    };
  });
  const handleWindowBeforeUnload = (ev: BeforeUnloadEvent): string => {
    return 'Unsaved changes. Are you sure?';
  };

  return (
    <VideoProvider options={connectionOptions} onError={setError}>
      <ErrorDialog dismissError={() => setError(null)} error={error} />
      <ChatProvider>
        <App />
      </ChatProvider>
    </VideoProvider>
  );
};

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <UnsupportedBrowserWarning>
      <Router>
        <AppStateProvider>
          <Routes>
            <Route
              path="/room/:URLRoomName"
              element={
                <PrivateRoute>
                  <VideoApp />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <PortalPage />
                </PrivateRoute>
              }
            />
            {/* <Route path="/login" element={<LoginPage />} /> */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppStateProvider>
      </Router>
    </UnsupportedBrowserWarning>
  </ThemeProvider>
);
